// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2hI0S","bigColWidth":"Table_bigColWidth__lziMa","biggerColWidth":"Table_biggerColWidth__SaT-P","row":"Table_row__1H0KG","col":"Table_col__2EJhj"};